import { makeStyles } from '@fluentui/react-components';
import { useState } from 'react';

import { SearchBox, SectionLabel } from '../components';
import { palette, tokens } from '../theme';
import { useWorkItemSearch, WorkItemResultRow, type WorkItemSearchView } from '../work-items';

export type QuickAddSectionProps = {
    selected: WorkItemSearchView | null;
    onSelect: (item: WorkItemSearchView) => void;
};

export const QuickAddSection: React.FC<QuickAddSectionProps> = ({ selected, onSelect }) => {
    const classes = useStyles();

    const [query, setQuery] = useState('');
    const { results, loading: searchInFlight } = useWorkItemSearch(query, 200);

    return (
        <div className={classes.root}>
            <SectionLabel text="Quick add" />

            <SearchBox value={query} onChange={setQuery} />

            <div className={classes.results}>
                {searchInFlight ? (
                    <p className={classes.searchingText}>Searching…</p>
                ) : results.length === 0 ? null : (
                    <div className={classes.resultsScroll}>
                        {results.map((item) => (
                            <WorkItemResultRow key={item.id} item={item} selected={selected?.id === item.id} onSelect={onSelect} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        flexGrow: 1,
    },
    results: {
        flexGrow: 1,
        minHeight: 0,
        marginTop: tokens.spacingVerticalS,
    },
    resultsScroll: {
        height: '100%',
        overflowY: 'auto',
        paddingRight: tokens.spacingHorizontalS,
    },
    searchingText: {
        margin: `${tokens.spacingVerticalS} 0 0 0`,
        fontSize: '12px',
        color: palette.dimText,
    },
});
